export default "__VITE_ASSET__cc7fa8ef__"